module.exports = __webpack_public_path__ + "img/card_gm.7ee8cc59.png";